import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, Inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PropertyListModel } from '../models/property-list.model';

@Injectable({
  providedIn: 'root',
})
export class MapService {
  public selectedProperty = signal<PropertyListModel>(new PropertyListModel());
  markerPositions: google.maps.LatLngLiteral[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {}

  defaultFacilities(): number[] {
    const facilities = this.activatedRoute?.snapshot?.queryParamMap?.get('f');
    if (facilities) {
      const facilityArray: number[] = facilities.split(',').map((x) => +x);
      return facilityArray;
    }
    return [];
  }

  defaultPropertyType(): string[] {
    const propertyTypes =
      this.activatedRoute?.snapshot?.queryParamMap?.get('t');
    if (propertyTypes) {
      const propertyTypeArray = propertyTypes.split(',');
      return propertyTypeArray;
    }
    return [];
  }

  setMarkedProperty(property: PropertyListModel): google.maps.LatLngLiteral {
    if (isPlatformBrowser(this.platformId)) {
      this.selectedProperty.set(property);

      document.querySelectorAll('.marked').forEach((el) => {
        el.classList.remove('marked');
      });

      if (!property.Latitude || !property.Longitude) {
        return this.markerPositions[0];
      }

      let el = document.getElementById('property-' + property.Id);
      if (el) {
        el.classList.add('marked');
      }

      this.markerPositions.push({
        lat: property.Latitude,
        lng: property.Longitude,
      });
    }

    return this.markerPositions[0];
  }

  defaultRatingFilter(): number {
    let defaultRating = this.getQueryParam('r');
    if (defaultRating) {
      return +defaultRating;
    }
    return 0;
  }

  defaultCustomerRatingFilter(): number {
    let defaultRating = this.getQueryParam('c');
    if (defaultRating) {
      return +defaultRating;
    }
    return 0;
  }

  updateRatingFilter(rating: number) {
    // this.ratingFilter.next(rating);

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { r: rating },
      queryParamsHandling: 'merge',
    });
  }

  updateCustomerRatingFilter(rating: number) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { c: rating },
      queryParamsHandling: 'merge',
    });
  }

  changeFacilities(facilities: number[]) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { f: facilities.join(',') },
      queryParamsHandling: 'merge',
    });
  }

  changePropertyTypes(propertyTypes: string[]) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { t: propertyTypes.join(',') },
      queryParamsHandling: 'merge',
    });
  }

  getQueryParam(param: string) {
    let value;
    this.activatedRoute?.queryParams?.subscribe((params) => {
      value = params[param];
    });
    if (!value) {
      return '';
    }
    return value;
  }
}
